import React from 'react';
import Draggable from 'react-draggable';
import axios from '../../../axios-config.js';
import {connect} from 'react-redux';
import {closeModal} from '../../../Redux/actions/ui.js';

let CloseButton = (props) => {
  return (
    <div onClick={props.handleClick} className="ProjectHistoryHeaderBtn close">
      <i className="material-icons notranslate">close</i>
    </div>
  )
}

let MinimizeButton = (props) => {
  return (
    <div className="ProjectHistoryHeaderBtn" onClick={props.toggleMinimize}>
      <i className="material-icons notranslate">{props.minimized ? "crop_square" : "remove"}</i>
    </div>
  )
}

let ColorLegend = () => {
  return (
    <div className="projectHistoryLegend">
      <div className="legendItem">
        <span className="legendColor" style={{backgroundColor: "#108710"}}></span>
        <span className="legendLabel">Public Version</span>
      </div>
      <div className="legendItem">
        <span className="legendColor" style={{backgroundColor: "#ff7b00"}}></span>
        <span className="legendLabel">Review Version</span>
      </div>
    </div>
  )
}

let AssetForm = (props) => {
  let createdAt = new Date(props.created_at);
  let dateStr = createdAt.toLocaleDateString();
  let timeStr = createdAt.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

  let style = {};

  if (props.reviewID === props.id) {
    style.backgroundColor = "#ff7b00";
  }else if (props.publicID === props.id) {
    style.backgroundColor = "#108710";
  }

  let handleSet = () => {
    if (window.confirm('This will change the current Review Version to the selected one. Are you sure?')) {
      axios.post(`/project/${props.activeProject}/scene/set`,{sceneID:props.id})
      .then((result) => {
        Inventum.notifications.addNotification({content:"Changed Review Version. Please Reload",displayTime:10000})
      })
      .catch((error) => {
        console.log(error);
      })
    }
  }

  let author = "";
  if (props.first_name)  {
    author = props.first_name;
  }else {
    author = 'Unknown'
  }

  return (
    <tr style={style}>
      <td>{props.id}</td>
      <td>{dateStr} {timeStr}</td>
      <td>{props.parent_id}</td>
      <td>{author}</td>
      <td className="WorldEditorButton" onClick={handleSet}>Set</td>
    </tr>
  )
}

class AssetsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scenes:[]
    };
    this.getScenes = this.getScenes.bind(this);
  }

  componentDidMount() {
    this.getScenes();
  }

  getScenes() {
    axios.get(`/project/${this.props.activeProject}/scene/list`)
    .then((result) => {
      console.log(result);
      this.setState({scenes:result.data.scenes,publicID:result.data.publicID,reviewID:result.data.reviewID})
    })
    .catch((error) => {
      console.log(error);
    })
  }

  render() {
    return (
      <div className="WorldEditorDrawer">
        <ColorLegend />
        <table className="ProjectHistoryTableContainer ProjectHistoryTable">
          <thead>
            <tr>
              <th>ID</th>
              <th>Created At</th>
              <th>Parent ID</th>
              <th>Author</th>
              <th>Set as Review</th>
            </tr>
          </thead>
          <tbody>
            {this.state.scenes.map((scene, index) => (
              <AssetForm
                activeProject={this.props.activeProject}
                reviewID={this.state.reviewID}
                publicID={this.state.publicID}
                key={index}
                {...scene}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

function WindowControls(props) {
  return (
    <div className="ProjectHistoryControls">
      {/* <MinimizeButton minimized={props.minimized} toggleMinimize={props.toggleMinimize} /> */}
      <CloseButton handleClick={props.handleClose} />
    </div>
  )
}

class ProjectHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {title:"Project History"}
    this.setTitle = this.setTitle.bind(this);
    this.toggleMinimize = this.toggleMinimize.bind(this);
  }

  toggleMinimize(force) {
    if (typeof(force) === "boolean") {
      this.setState({minimized:force});
    } else {
      this.setState({minimized:!this.state.minimized});
    }
  }

  setTitle(newTitle) {
    this.setState({title:newTitle})
  }

  render () {
    return (
      <Draggable handle=".ProjectHistoryHeader">
      <div className={"WorldEditorContainer" + (this.state.minimized ? " minimized" : "")}>
        <div className="ProjectHistoryHeader"><span className="ProjectHistoryTitle">{this.state.title}</span><WindowControls minimized={this.state.minimized} toggleMinimize={this.toggleMinimize} handleClose={this.props.closeModal} /></div>
          {this.state.minimized ? null : <AssetsList closeModal={this.props.closeModal} activeProject={this.props.activeProject} modalOptions={this.props.modalOptions} />}
        </div>
      </Draggable>
    )
  }
}


let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  }
})

let mapStateToProps = (state) => ({
  activeProject:state.ui.activeProject,
  modalOptions:state.ui.modalOptions
})

const InventumProjectHistoryContainer = connect(mapStateToProps,mapDispatchToProps)(ProjectHistory)

export default InventumProjectHistoryContainer
